/**
 * @description 吸底的按钮
 */
import Button, { ButtonProps } from 'components/base/Button';
import classlist from 'utils/classlist';
import styles from './style.scss';

export interface StickyButtonProps extends ButtonProps, Omit<React.ComponentPropsWithRef<'button'>, 'type' | 'ref'> {
    btnContent: React.ReactNode;
    className?: string;
}

const StickyButton: React.FC<StickyButtonProps> = props => {
    const { children, btnContent, className, ...btnProps } = props;

    return (
        <div className={classlist(styles.root, className)}>
            {children}
            <Button className={styles.stickyBtn} {...btnProps}>
                {btnContent}
            </Button>
        </div>
    );
};

export default StickyButton;
